import "../../../chunks/server.js";
//#region src/routes/purchaseconfirmed/+page.svelte
function _page($$renderer) {
	$$renderer.push(`<div class="flex justify-center items-center h-[calc(100vh-64px)]"><h1 class="text-3xl">Under Construction</h1></div>`);
}
//#endregion
export { _page as default };
